<div class="bank-details-container">

    <div class="p-fluid p-formgrid top-card">
        <!-- <div class="field col-12 md:col-4">
            <div class="grid-item">
                <p-dropdown [options]="appStatusTypeList" appendTo="body" [(ngModel)]="selectedAppStatus"
                (onChange)="onSelectContractor()" placeholder="{{'Select Status'| translate}}" optionLabel="status_Description" [showClear]="false"></p-dropdown>
            </div>
        </div> -->
        <div class="field md:col-4 col-12">
            <div class="grid-item">
                <p-dropdown [options]="contractorList" [(ngModel)]="selectedContractor"
                    (onChange)="onSelectContractor()" appendTo="body" placeholder="{{ 'Select Contractor'| translate }}"
                    optionLabel="ContractorName"></p-dropdown>
            </div>
        </div>
        <div class="field md:col-4 col-12">
            <div class="grid-item">
                <p-dropdown [options]="contractorOutletList" [(ngModel)]="selectedOutlet" 
                    (onChange)="onSelectContractorOutlet()" appendTo="body" placeholder="{{ 'SELECT_OUTLET_RD'| translate }}" optionLabel="Outlets"></p-dropdown>
            </div>
        </div>
    </div>

    <!-- Visible on Small screens -->
    <!-- <div class="block md:hidden">
        <div *ngIf="loading">
            <div id="pause" class="flex align-items-center justify-content-center">
                <div id="spinner"></div>
            </div>
        </div>
        <div class="landing">
            <div class="header-container">
                <div class="icon">
                </div>
                <div class="header">
                    <p>{{'WELOCOME_TO'| translate}}</p>
                    <p>{{'MICADA_MOBILE_APPLICATION'| translate}}</p>
                </div>
                <div class="subheader">
                    <p> {{'EFFICIENT_AND_ELEGANT_WAY_TO_VERIFY_SITE'| translate}}</p>
                </div>
            </div>
        </div>
        <div style="padding: 0 1em;">
            <p-toolbar styleClass="mb-4" reflow="true">
                <ng-template pTemplate="left"></ng-template>
                <ng-template pTemplate="right">
                    <button *ngIf="mobileFarmerUHBVNpvData.length > 0" (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                        class="p-button-help"></button>
                        <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}" icon="pi pi-refresh"
                                  class="p-button-info ml-3"></button>
                    <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
                </ng-template>
                   </p-toolbar>
            <p-card class="mobile-card"> <div class="mobile_search">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="mobileSearch($any($event.target).value)"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
            </div></p-card>
            <p-card styleClass="p-card-shadow my-2 widthFull" *ngFor="let item of mobileFarmerUHBVNpvData"
                (click)="selectPreSurveyData(item)" [style]="{'color': 'black', 'background-color': rowBackgroundColor(item)}">
                <table cellspacing="10">
                    <tr>
                        <td class="fontXl"><b>{{'APP_ID'| translate}}</b></td>
                        <td class="fontXl"><b>{{item.AppId}}</b>
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'FARMER_NAME'| translate}}</b></td>
                        <td>
                            {{item.Farmer_Name}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'MOBILE_NO'| translate}}</b></td>
                        <td>
                            {{item.FarmerMobile}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'FATHERS_NAME'| translate}}</b></td>
                        <td>
                            {{item.Father_Name}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'VILLAGE'| translate}}</b></td>
                        <td>
                            {{item.VillageName}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'VENDOR_NAME'| translate}}</b></td>
                        <td>
                            {{item.VendorFullName}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'PROGRAMME_NAME'| translate}}</b></td>
                        <td>
                            {{item.Program_Name}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'KILLA_NO'| translate}}</b></td>
                        <td>
                            {{item.KillaNo}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'TOTAL_AREA_IN_ACRE'| translate}}</b></td>
                        <td>
                            {{item.AreaAcre}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'FINANCIAL_YEAR'| translate}}</b></td>
                        <td>
                            {{item.Fin_Year}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'Status'| translate}}</b></td>
                        <td>
                            {{item.JE_Status}}
                        </td>
                    </tr>
                    <tr>
                        <td><b>{{'ESTIMATION_ACTION'| translate}}</b></td>
                        <td  *ngIf="!(isJeLogin && item?.JE_Status == 'Approved' || isXenLogin && item?.XEN_Status == 'Done')">
                            <button pButton pRipple type="button" pTooltip="Add-Estimation" icon="pi pi-plus"
                                class="p-button-rounded p-button-text" (click)="addEstimation(item)"></button>
                        </td>
                        <td  *ngIf="(isJeLogin && item?.JE_Status == 'Approved' || isXenLogin && item?.XEN_Status == 'Done')">
                            <button pButton pRipple type="button" pTooltip="Edit-Estimation"
                                (click)="updateEstimation(item)" icon="pi pi-pencil"
                                class="p-button-rounded p-button-text"></button>
                        </td>
                    </tr>
                </table>
            </p-card>
        </div>
    </div> -->

    <!-- <div class="grid hidden md:block mt-2"> -->
    <div *ngIf="showDetailTable" class="grid">
        <div class="col-12">
            <div class="card">
                <div class="dashboardTable">
                    <p-table #readyForPaymentTable [value]="readyForPaymentData" [(selection)]="filteredDataForExport" dataKey="APP_ID"
                    (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)" (onHeaderCheckboxToggle)="onHeaderCheckboxToggle($event)"
                    styleClass="p-datatable-gridlines" scrollHeight="500px" [rows]="10" [paginator]="true"
                        [globalFilterFields]="[
                        'APP_ID',
                        'Name',
                        'Father_name',
                        'Mobile',
                        'ContractorName',
                        'Outlets',
                        'AgreementNo',
                        'ProposedSystem',
                        'TotalArea',
                        'Village',
                        'District',
                        'Block',
                        'XEN_Remarks', 
                        'XEN_Status', 
                        'JE_Remarks', 
                        'JE_Status', 
                        'JEID',
                        'ReVerRemarksXEN',
                        'TotalRecommendedAmt',
                        'LotStatus',
                        'FarmerType',
                        'Caste_Description',
                        'OfflinePaymentStatus',
                        'RDName',
                        'NameOfContractor',
                        'KILLA_NO',
                        'MARABBA_NO',
                        'AppliedMIArea',
                        'LotCentre_share_amt',
                        'LotState_share_amt',
                        'LotTopUp',
                        'CalcType',
                        'ProdataAmt'
                        ]" responsiveLayout="scroll" [rowHover]="true" sortMode="multiple"
                        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                        [showCurrentPageReport]="true" [loading]="loading">
                        <ng-template pTemplate="caption">
                            <div class="flex align-items-center justify-content-between">
                                <!-- Left side -->
                                <div class="col-5">
                                    <h5 class="m-0 table-header-text">{{'Application for Approval'| translate}}</h5>
                                </div>
                                <!-- Middle section for buttons -->
                                <div class="col-4 d-flex  justify-content-between">
                                    <button (click)="refreshTable()" pButton pRipple label="" icon="pi pi-refresh"
                                        class="p-button-info mx-1"></button>
                                    <p-splitButton *ngIf="filteredDataForExport.length > 0" [model]="appVerificationItems" icon="pi pi-download" label="{{'' | translate}}"></p-splitButton>
                                    <!-- <button *ngIf="readyForPaymentData.length > 0" (click)="menu.toggle($event)" pButton
                                        pRipple label="" icon="pi pi-download" class="p-button-help mx-1"></button>
                                    <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu> -->
                                </div>
                                <!-- Right side for search -->
                                <div class="col-3 d-flex align-items-center justify-content-end">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input pInputText type="text"
                                            (input)="readyForPaymentTable.filterGlobal($any($event.target).value, 'contains')"
                                            placeholder="{{'SEARCH'| translate}}" />
                                    </span>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width: 3rem">
                                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                                </th>
                                <th pSortableColumn="APP_ID">{{'APP_ID'| translate}}
                                    <p-columnFilter type="text" field="APP_ID" display="menu"></p-columnFilter>
                                    <p-sortIcon field="APP_ID"></p-sortIcon>
                                </th>
                                <th pSortableColumn="Name">{{'FARMER_NAME'| translate}}
                                    <p-columnFilter type="text" field="Name" display="menu"></p-columnFilter>
                                    <p-sortIcon field="Name"></p-sortIcon>
                                </th>
                                <th pSortableColumn="FarmerType">{{'FARMER_TYPE'| translate}}
                                    <p-columnFilter type="text" field="FarmerType" display="menu"></p-columnFilter>
                                    <p-sortIcon field="FarmerType"></p-sortIcon>
                                </th>
                                <th pSortableColumn="Caste_Description">{{'CASTE'| translate}}
                                    <p-columnFilter type="text" field="Caste_Description" display="menu"></p-columnFilter>
                                    <p-sortIcon field="Caste_Description"></p-sortIcon>
                                </th>
                                <th pSortableColumn="ProposedSystem">{{'PROGRAMME_NAME'| translate}}
                                    <p-columnFilter type="text" field="ProposedSystem" display="menu"></p-columnFilter>
                                    <p-sortIcon field="ProposedSystem"></p-sortIcon>
                                </th>
                                <th pSortableColumn="District">{{'DISTRICT'| translate}}
                                    <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                                    <p-sortIcon field="District"></p-sortIcon>
                                </th>
                                <th pSortableColumn="Village">{{'VILLAGE'| translate}}
                                    <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
                                    <p-sortIcon field="Village"></p-sortIcon>
                                </th>
                                <th pSortableColumn="Block">{{'BLOCK'| translate}}
                                    <p-columnFilter type="text" field="Block" display="menu"></p-columnFilter>
                                    <p-sortIcon field="Block"></p-sortIcon>
                                </th>
                                <th pSortableColumn="Father_name">{{'FATHERS_NAME'| translate}}
                                    <p-columnFilter type="text" field="Father_name" display="menu"></p-columnFilter>
                                    <p-sortIcon field="Father_name"></p-sortIcon>
                                </th>
                                <th pSortableColumn="Mobile">{{'MOBILE_NO'| translate}}
                                    <p-columnFilter type="text" field="Mobile" display="menu"></p-columnFilter>
                                    <p-sortIcon field="Mobile"></p-sortIcon>
                                </th>
                                <th pSortableColumn="ContractorName">{{'CONTRACTOR_NAME'| translate}}
                                    <p-columnFilter type="text" field="ContractorName" display="menu"></p-columnFilter>
                                    <p-sortIcon field="ContractorName"></p-sortIcon>
                                </th>
                                <th pSortableColumn="Outlets">{{'OUTLET'| translate}}
                                    <p-columnFilter type="text" field="Outlets" display="menu"></p-columnFilter>
                                    <p-sortIcon field="Outlets"></p-sortIcon>
                                </th>
                                <th pSortableColumn="AmountPerAcre">{{'RATE_PER_HA'| translate}}
                                    <p-columnFilter type="text" field="AmountPerAcre" display="menu"></p-columnFilter>
                                    <p-sortIcon field="AmountPerAcre"></p-sortIcon>
                                </th>
                                <th pSortableColumn="AgreementNo">{{'AGREEMENT_NO'| translate}}
                                    <p-columnFilter type="text" field="AgreementNo" display="menu"></p-columnFilter>
                                    <p-sortIcon field="AgreementNo"></p-sortIcon>
                                </th>
                                <th pSortableColumn="TotalArea">{{'TOTAL_AREA'| translate}}
                                    <p-columnFilter type="text" field="TotalArea" display="menu"></p-columnFilter>
                                    <p-sortIcon field="TotalArea"></p-sortIcon>
                                </th>
                                <!-- <th>{{'XEN_STATUS'| translate}}</th>
                                <th>{{'XEN_REMARKS'| translate}}</th>
                                <th>{{'JE_ID'| translate}}</th>
                                <th>{{'JE_STATUS'| translate}}</th>
                                <th>{{'JE_REMARKS'| translate}}</th> -->
                                <th pSortableColumn="ReVerRemarksXEN">{{'XEN_RE_VER_REMARKS'| translate}}
                                    <p-columnFilter type="text" field="ReVerRemarksXEN" display="menu"></p-columnFilter>
                                    <p-sortIcon field="ReVerRemarksXEN"></p-sortIcon>
                                </th>
                                <th pSortableColumn="TotalRecommendedAmt">{{'Recommended Amt.'| translate}}
                                    <p-columnFilter type="text" field="TotalRecommendedAmt" display="menu"></p-columnFilter>
                                    <p-sortIcon field="TotalRecommendedAmt"></p-sortIcon>
                                </th>
                                <th pSortableColumn="totalCost85Per">{{'SUBSIDY_AMOUNT'| translate}}
                                    <p-columnFilter type="text" field="totalCost85Per" display="menu"></p-columnFilter>
                                    <p-sortIcon field="totalCost85Per"></p-sortIcon>
                                </th>
                                <th pSortableColumn="LotCentre_share_amt">{{'CENTER_SHARE_PAYMENT_AMOUNT'| translate}}
                                    <p-columnFilter type="text" field="LotCentre_share_amt" display="menu"></p-columnFilter>
                                    <p-sortIcon field="LotCentre_share_amt"></p-sortIcon>
                                </th>
                                <th pSortableColumn="LotState_share_amt">{{'STATE_SHARE_PAYMENT_AMOUNT'| translate}}
                                    <p-columnFilter type="text" field="LotState_share_amt" display="menu"></p-columnFilter>
                                    <p-sortIcon field="LotState_share_amt"></p-sortIcon>
                                </th>
                                <th pSortableColumn="LotTopUp">{{'TOP_UP_AMOUNT'| translate}}
                                    <p-columnFilter type="text" field="LotTopUp" display="menu"></p-columnFilter>
                                    <p-sortIcon field="LotTopUp"></p-sortIcon>
                                </th>
                                <th pSortableColumn="LotStatus">{{'LOT_STATUS'| translate}}
                                    <p-columnFilter type="text" field="LotStatus" display="menu"></p-columnFilter>
                                    <p-sortIcon field="LotStatus"></p-sortIcon>
                                </th>
                                <th pSortableColumn="ProdataAmt">{{'Recommended Subsidy'| translate}}
                                    <p-columnFilter type="text" field="ProdataAmt" display="menu"></p-columnFilter>
                                    <p-sortIcon field="ProdataAmt"></p-sortIcon>
                                </th>
                                <th pSortableColumn="CalcType">{{'Calculation Criteria'| translate}}
                                    <p-columnFilter type="text" field="CalcType" display="menu"></p-columnFilter>
                                    <p-sortIcon field="CalcType"></p-sortIcon>
                                </th>
                                <th pSortableColumn="OfflinePaymentStatus">{{'PAYMENT_STATUS'| translate}}
                                    <p-columnFilter type="text" field="OfflinePaymentStatus" display="menu"></p-columnFilter>
                                    <p-sortIcon field="OfflinePaymentStatus"></p-sortIcon>
                                </th>
                                <th pSortableColumn="RDName">{{'RD'| translate}}
                                    <p-columnFilter type="text" field="RDName" display="menu"></p-columnFilter>
                                    <p-sortIcon field="RDName"></p-sortIcon>
                                </th>
                                <th pSortableColumn="NameOfContractor">{{'CONTRACTOR_NAME'| translate}}
                                    <p-columnFilter type="text" field="NameOfContractor" display="menu"></p-columnFilter>
                                    <p-sortIcon field="NameOfContractor"></p-sortIcon>
                                </th>
                                <th pSortableColumn="KILLA_NO">{{'KILLA_NO'| translate}}
                                    <p-columnFilter type="text" field="KILLA_NO" display="menu"></p-columnFilter>
                                    <p-sortIcon field="KILLA_NO"></p-sortIcon>
                                </th>
                                <th pSortableColumn="MARABBA_NO">{{'MORABBA_NO'| translate}}
                                    <p-columnFilter type="text" field="MARABBA_NO" display="menu"></p-columnFilter>
                                    <p-sortIcon field="MARABBA_NO"></p-sortIcon>
                                </th>
                                <th pSortableColumn="AppliedMIArea">{{'APPLIED_AREA'| translate}}
                                    <p-columnFilter type="text" field="AppliedMIArea" display="menu"></p-columnFilter>
                                    <p-sortIcon field="AppliedMIArea"></p-sortIcon>
                                </th>
                                <!-- <th>{{'ACTION'| translate}}</th> -->
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-product>
                            <tr [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(product)}">
                                <td>
                                    <p-tableCheckbox [value]="product" [disabled]="product.LotStatus == 'Success'"></p-tableCheckbox>
                                </td>
                                <td>{{product.APP_ID}}</td>
                                <td>{{product.Name}}</td>
                                <td>{{product.FarmerType}}</td>
                                <td>{{product.Caste_Description}}</td>
                                <td>{{product.ProposedSystem}}</td>
                                <td>{{product.District}}</td>
                                <td>{{product.Block}}</td>
                                <td>{{product.Village}}</td>
                                <td>{{product.Father_name}}</td>
                                <td>{{product.Mobile}}</td>
                                <td>{{product.ContractorName}}</td>
                                <td>{{product.Outlets}}</td>
                                <td>{{product.AmountPerAcre | number: "1.2-2" }}</td>
                                <td>{{product.AgreementNo}}</td>
                                <td>{{product.TotalArea}}</td>
                                <!-- <td>{{product.XEN_Status}}</td>
                                <td>{{product.XEN_Remarks}}</td>
                                <td>{{product.JEID}}</td>
                                <td>{{product.JE_Status}}</td>
                                <td>{{product.JE_Remarks}}</td> -->
                                <td>{{product.ReVerRemarksXEN}}</td>
                                <td>{{product.TotalRecommendedAmt}}</td>
                                <td>{{product.totalCost85Per}}</td>
                                <td>{{product.LotCentre_share_amt}}</td>
                                <td>{{product.LotState_share_amt}}</td>
                                <td>{{product.LotTopUp}}</td>
                                <td>{{product.LotStatus}}</td>
                                <td>{{product.ProdataAmt  | number: "1.2-2" }}</td>
                                <td>{{product.CalcType}}</td>
                                <!-- <td><button pButton pRipple pTooltip="view application" icon="pi pi-file"
                                    class="p-button-rounded p-button-accent mr-1 btnSize"
                                    (click)="selectViewApplication(product,product?.Status_Ar)"></button></td> -->
                                <!-- <td>
                                    <button *ngIf="product.ReVerificationStatus != 'Approved'" pButton pRipple type="button" pTooltip="" icon="pi pi-plus"
                                    class="p-button-rounded p-button-text"
                                    (click)="onClickAppAction(product)"></button>
                                    <button
                                    *ngIf="(isJeLogin && product?.JE_Status == 'Approved' || isXenLogin && product?.XEN_Status == 'Done')"
                                    pButton pRipple type="button" pTooltip="" (click)="updateEstimation(product)"
                                    icon="pi pi-pencil" class="p-button-rounded p-button-text"></button>
                                </td> -->
                                <td>{{product.OfflinePaymentStatus}}</td>
                                <td>{{product.RDName}}</td>
                                <td>{{product.NameOfContractor}}</td>
                                <td>{{product.KILLA_NO}}</td>
                                <td>{{product.MARABBA_NO}}</td>
                                <td>{{product.AppliedMIArea}}</td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="summary">
                            <div class="flex  justify-content-between flex-column">
                                <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{readyForPaymentData ? readyForPaymentData.length : 0 }}
                                    {{'Application(s) Ready for Payment'| translate}}.
                                </p>
                                <div class="flex  justify-content-between flex-column "> 
                                    <!-- <div class="flex"><div style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING_MORE_THAN_TWO_DAYS'| translate}}</div> -->
                                    <div class="flex"><div style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'Offline Payment Done'| translate}}</div>
                                    <div class="flex"><div style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'Lot Generated'| translate}}</div>
                                    <div class="flex"><div style="background-color:#ffb3b3 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING'| translate}}</div>
                                </div>
                            </div>
                            <!-- <div class="flex align-items-center justify-content-between">
                                {{'IN_TOTAL_THERE_ARE'| translate}} {{readyForPaymentData ?
                                readyForPaymentData.length : 0 }} {{'FARMER_PRE_SURVEY_ADDED'| translate}}.
                            </div> -->
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="7">No Data found.</td>
                            </tr>
                        </ng-template>
                    </p-table>

                </div>
                <div *ngIf="totalSelectedApp" class="p-fluid p-formgrid card mt-2">

                    <form [formGroup]="uploadDetailsForm" (ngSubmit)="onSubmitDetails()">
                        <div class="p-fluid p-formgrid justify-content-center upload-card" style="display: flex; flex-wrap:wrap">
                            <!-- <div class="field md:col-3 col-12">
                                <label for="gstRate">{{'GST_RATE_PER' | translate}}</label>
                                <input pInputText type="text" id="gstRate" formControlName="gstRate" placeholder="{{'ENTER_TAX_RATE' | translate}}" />
                                <div *ngIf="uploadFormControls.gstRate.touched && uploadFormControls.gstRate.errors" class="invalid-feedback">
                                    <div *ngIf="uploadFormControls.gstRate.errors.required">
                                        {{'GST_RATE_IS_REQUIRED' | translate}}
                                    </div>
                                    <div *ngIf="uploadFormControls.gstRate.errors.min">
                                        {{'TAX_RATE_MUST_BE_POSITIVE' | translate}}
                                    </div>
                                </div>
                            </div> -->
                            <!-- <div class="field md:col-3 col-12 ">
                                <label for="itRate">{{'INCOME_TAX_RATE' | translate}}</label>
                                <p-dropdown [options]="itRateList" formControlName="itRate"
                                    placeholder="{{'Select IT Tax'| translate}}" optionLabel="label" optionValue="value">
                                </p-dropdown>
                                <div *ngIf="uploadFormControls.itRate.touched && uploadFormControls.itRate.errors" class="invalid-feedback">
                                    <div *ngIf="uploadFormControls.itRate.errors.required">
                                        {{'INCOME_TAX_RATE_IS_REQUIRED' | translate}}
                                    </div>
                                    <div *ngIf="uploadFormControls.itRate.errors.min">
                                        {{'TAX_RATE_MUST_BE_POSITIVE' | translate}}
                                    </div>
                                </div>
                            </div> -->
                            <!-- <div class="field md:col-3 col-12">
                                <label for="itRate">{{'INCOME_TAX_RATE' | translate}}</label>
                                <input pInputText type="number" id="itRate" formControlName="itRate" min="0" step="0.01" onwheel="this.blur()" placeholder="{{'ENTER_TAX_RATE' | translate}}" />
                                <div *ngIf="uploadFormControls.itRate.touched && uploadFormControls.itRate.errors" class="invalid-feedback">
                                    <div *ngIf="uploadFormControls.itRate.errors.required">
                                        {{'INCOME_TAX_RATE_IS_REQUIRED' | translate}}
                                    </div>
                                    <div *ngIf="uploadFormControls.itRate.errors.min">
                                        {{'TAX_RATE_MUST_BE_POSITIVE' | translate}}
                                    </div>
                                </div>
                            </div> -->
                            <!-- <div class="field md:col-3 col-12">
                                <label for="labourCessRate">{{'LABOUR_CESS_RATE' | translate}}</label>
                                <input pInputText type="text" id="labourCessRate" formControlName="labourCessRate" placeholder="{{'ENTER_TAX_RATE' | translate}}" />
                                <div *ngIf="uploadFormControls.labourCessRate.touched && uploadFormControls.labourCessRate.errors" class="invalid-feedback">
                                    <div *ngIf="uploadFormControls.labourCessRate.errors.required">
                                        {{'LABOUR_CESS_RATE_IS_REQUIRED' | translate}}
                                    </div>
                                    <div *ngIf="uploadFormControls.labourCessRate.errors.min">
                                        {{'TAX_RATE_MUST_BE_POSITIVE' | translate}}
                                    </div>
                                </div>
                            </div> -->
                            <div class="field md:col-6 col-12">
                                <label htmlFor="block">{{'UPLOAD_MB' | translate}}</label>
                                <div class="flex">
                                    <p-fileUpload accept=".jpeg,.pdf,.jpg" #epcMBFileUpload [customUpload]="true"
                                        (uploadHandler)="onUpload($event, 'mbPhotoPath', epcMBFileUpload)"
                                        name="myfile[]" mode="basic" [maxFileSize]="10000000"
                                        chooseLabel="{{'BROWSE' | translate}}" [auto]="true">
                                    </p-fileUpload>
                                    <ng-container *ngIf="uploadFormControls.mbPhotoPath.value as mb">
                                        <ng-container *ngIf="mb.split('?')[0].toLowerCase().endsWith('.pdf'); else imgTpl">
                                            <a [href]="mb" target="_blank" rel="noopener noreferrer" class="p-button p-button-text ml-2 view-file-link">
                                                View File
                                            </a>
                                        </ng-container>
                                        <ng-template #imgTpl>
                                            <p-image [src]="mb" alt="Image" width="70" class="ml-2 p-button-rounded p-button-success" iconPos="left" [preview]="false"></p-image>
                                        </ng-template>
                                    </ng-container>
                                </div>

                                <div *ngIf="uploadFormControls.mbPhotoPath.touched && uploadFormControls.mbPhotoPath.errors"
                                    class="invalid-feedback">
                                    <div *ngIf="uploadFormControls.mbPhotoPath.errors.required">
                                        {{'UPLOAD_IS_REQUIRED' |
                                        translate}}</div>
                                </div>
                            </div>
                            <div class="field md:col-6 col-12">
                                <label htmlFor="block">{{'UPLOAD_TAX_CALCULATIONS_AND_RECOVERY_SHEET' | translate}}</label>
                                <div class="flex">
                                    <p-fileUpload accept=".jpeg,.pdf,.jpg" #taxMBFileUpload [customUpload]="true"
                                        (uploadHandler)="onUpload($event, 'taxPhotoPath', taxMBFileUpload)"
                                        name="myfile[]" mode="basic" [maxFileSize]="10000000"
                                        chooseLabel="{{'BROWSE' | translate}}" [auto]="true">
                                    </p-fileUpload>
                                    <ng-container *ngIf="uploadFormControls.taxPhotoPath.value as mb">
                                        <ng-container *ngIf="mb.split('?')[0].toLowerCase().endsWith('.pdf'); else imgTpl">
                                            <a [href]="mb" target="_blank" rel="noopener noreferrer" class="p-button p-button-text ml-2 view-file-link">
                                                View File
                                            </a>
                                        </ng-container>
                                        <ng-template #imgTpl>
                                            <p-image [src]="mb" alt="Image" width="70" class="ml-2 p-button-rounded p-button-success" iconPos="left" [preview]="false"></p-image>
                                        </ng-template>
                                    </ng-container>
                                </div>

                                <div *ngIf="uploadFormControls.taxPhotoPath.touched && uploadFormControls.taxPhotoPath.errors"
                                    class="invalid-feedback">
                                    <div *ngIf="uploadFormControls.taxPhotoPath.errors.required">
                                        {{'UPLOAD_IS_REQUIRED' |
                                        translate}}</div>
                                </div>
                            </div>

                            <div class="field md:col-4 col-12">
                                <label for="remarks">{{'REMARKS' | translate}}</label>
                                <input pInputText type="text" id="remarks" formControlName="remarks" placeholder="{{'Remarks' | translate}}" />
                                <div *ngIf="uploadFormControls.remarks.touched && uploadFormControls.remarks.errors" class="invalid-feedback">
                                    <div *ngIf="uploadFormControls.remarks.errors.required">
                                        {{'REMARK_IS_REQUIRED' | translate}}
                                    </div>
                                </div>
                            </div>
                            <div class="field md:col-4 col-12 ">
                                <label for="status">{{'ACTION' | translate}}</label>
                                <p-dropdown [options]="statusList" formControlName="status"
                                    placeholder="{{'Select Action'| translate}}" optionLabel="label" optionValue="value">
                                </p-dropdown>
                                <div *ngIf="uploadFormControls.status.touched && uploadFormControls.status.errors" class="invalid-feedback">
                                    <div *ngIf="uploadFormControls.status.errors.required">
                                        {{'ACTION_IS_REQUIRED' | translate}}
                                    </div>
                                </div>
                            </div>

                            <div class="field md:col-12 col-12 my-0 py-0 consent-checkboxes">
                                <label class="form-check-label pt-2" for="consentCheckbox1">
                                    <input type="checkbox" class="form-check-input" id="consentCheckbox1"
                                        formControlName="consentCheckboxValue1">
                                    &nbsp; It is certified that all the MI calculations have been done as per PDMC guidelines and the applicable contractor rates are duly approved by competent authority.
                                </label>
                            </div>
                            <div class="field md:col-12 col-12 my-0 py-0 consent-checkboxes">
                                <label class="form-check-label pt-2" for="consentCheckbox2">
                                    <input type="checkbox" class="form-check-input" id="consentCheckbox2"
                                        formControlName="consentCheckboxValue2">
                                    &nbsp; The cases are submitted for release of payment to the contractor.
                                </label>
                            </div>
                            <div class="field md:col-12 col-12 my-0 py-0 consent-checkboxes">
                                <label class="form-check-label pt-2" for="consentCheckbox3">
                                    <input type="checkbox" class="form-check-input" id="consentCheckbox3"
                                        formControlName="consentCheckboxValue3">
                                    &nbsp; All MI Systems installed as per approved specifications and based on the area specified by the farmer in their applications and within approved cost/ estimate.
                                </label>
                            </div>
                            <div class="field md:col-12 col-12 my-0 py-0 consent-checkboxes">
                                <label class="form-check-label pt-2" for="consentCheckbox4">
                                    <input type="checkbox" class="form-check-input" id="consentCheckbox4"
                                        formControlName="consentCheckboxValue4">
                                    &nbsp; All required documents have been verified and uploaded on the EPC-MI module on portal.
                                </label>
                            </div>
                        </div>


                        <div class="field col-12 export-msg-div">
                            <p>{{ 'In total there are '}} {{totalSelectedApp}} {{' application(s) selected for lot geneation.'}}</p>
                        </div>

                        <div class="field col-12 text-right mt-3">
                            <button pButton type="submit" label="{{'SUBMIT' | translate}}" 
                                class="p-button p-button-success">
                                <!-- [disabled]="uploadDetailsForm.invalid"> -->
                            </button>
                        </div>
                    </form>

                    <!-- <div class="field md:col-2 col-12">
                        <button (click)="menu.toggle($event)" pButton
                            pRipple label="" icon="pi pi-download" class="p-button-help mx-1"></button>
                        <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
                    </div> -->
                </div>
            </div>

            <div class="card">
                <div *ngIf="responseDate.length > 0">
                    <div class="dashboardTable">
                        <p-table #exportDataResponse [value]="responseDate" [rows]="15" [paginator]="true" [globalFilterFields]="[
                                'AppID',
                                'TotalAmt',
                                'Status',
                                'Remarks',
                                'Message',
                                ]" responsiveLayout="scroll" [rowHover]="true"
                            currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                            [showCurrentPageReport]="true" [loading]="loadingExportResponse">
                            <ng-template pTemplate="caption">
                                <div class="flex align-items-center justify-content-between">
                                    <h5 class="m-0">{{'EXPORT_DATA_RESPONSE'| translate}}</h5>
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input pInputText type="text"
                                            (input)="exportDataResponse.filterGlobal($any($event.target).value, 'contains')"
                                            placeholder="{{'SEARCH'| translate}}" />
                                    </span>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="header">
                                <tr>
                                    <th pSortableColumn="AppID">{{'APP_ID'| translate}}</th>
                                    <!-- <th pSortableColumn="TotalAmt">{{'AMOUNT'| translate}}</th> -->
                                    <th pSortableColumn="Status">{{'STATUS'| translate}}</th>
                                    <th pSortableColumn="Remarks">{{'REMARKS'| translate}}</th>
                                    <th pSortableColumn="Message">{{'MESSAGE'| translate}}</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-responseData>
                                <tr [ngStyle]="{'color': 'black', 'background-color': responseGridBackgroundColor(responseData)}">
                                    <td>{{responseData.AppID}}</td>
                                    <!-- <td>{{responseData.TotalAmt}}</td> -->
                                    <td>{{responseData.Status}}</td>
                                    <td>{{responseData.Remarks}}</td>
                                    <td>{{responseData.Message}}</td>
                                </tr>
                            </ng-template>

                        </p-table>
                    </div>

                    <div class="field col-12 text-right mt-3">
                        <button pButton type="submit" label="{{'Done' | translate}}" (click)="closeResponseTable()"
                            class="p-button p-button-info">
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>